module.exports = __webpack_public_path__ + "img/m_title.5bccbe01.png";